import { cn } from "src/lib/utils";

const TABS = [
  { id: "introduction", label: "소개" },
  { id: "profile", label: "프로필" },
] as const;

interface LawyerTabBarProps {
  activeTab: string;
  onTabClick: (tabId: string) => void;
}

export function LawyerTabBar({ activeTab, onTabClick }: LawyerTabBarProps) {
  return (
    <nav
      className={cn(
        "sticky top-16 z-40 bg-white border-b border-[#CCCCCC] mt-4 tablet:mt-12 desktop:mt-0",
        "desktop:border-b-0 desktop:w-[267px] desktop:shrink-0 desktop:self-start desktop:pt-[54px]",
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center",
          "desktop:flex-col desktop:items-start",
        )}
      >
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabClick(tab.id)}
            className={cn(
              "px-8 tablet:px-[84px]",
              "desktop:px-0 desktop:w-full desktop:text-left",
            )}
          >
            <span
              className={cn(
                "inline-block text-display-2-mb desktop:text-display-2 py-[18px] transition-colors duration-300",
                "border-b-4 desktop:border-b-0 desktop:border-l-[7px] desktop:pl-5",
                "desktop:py-2",
                activeTab === tab.id
                  ? "text-c-primary border-c-primary"
                  : "text-[#BBBBBB] border-transparent desktop:border-[#999999]",
              )}
            >
              {tab.label}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
}
